
/// Модель текущего банаса для запроса выводов
export class CurrentBalanceModel{
    /// Тип валюты
    public walletType: string;
     /// Доступная сумма для вывода
    public availableSum: string;
    /// Текущий баланс валюты
    public totalSum: string;
    /// Количество выводов ожидании
    public pendingWithdraws: number;
    /// Сумма всех выводов в ожидании для данной валюты
    public pendingSum: string;
    /// Минимальная сумма вывода
    public minSum: string;
    /// Адрес кошелька
    public walletAddress: string;
}


// WEBPACK FOOTER //
// ./src/app/core/models/currentBalanceModel.mode.ts